export function armarFechaString(
  fecha: Date,
  incluirDiaSemana: boolean = true
) {
  const diaNumber = fecha.getDay();
  const mesNumber = fecha.getMonth();
  const anio = fecha.getFullYear();
  const dia = fecha.getDate();

  let diaSemana: string;
  let mes: string;

  switch (diaNumber - 1) {
    case 0:
      diaSemana = 'Lunes';
      break;
    case 1:
      diaSemana = 'Martes';
      break;
    case 2:
      diaSemana = 'Miercoles';
      break;
    case 3:
      diaSemana = 'Jueves';
      break;
    case 4:
      diaSemana = 'Viernes';
      break;
    case 5:
      diaSemana = 'Sabado';
      break;
    case 6:
      diaSemana = 'Domingo';
      break;
  }

  switch (mesNumber) {
    case 0:
      mes = 'Enero';
      break;
    case 1:
      mes = 'Febrero';
      break;
    case 2:
      mes = 'Marzo';
      break;
    case 3:
      mes = 'Abril';
      break;
    case 4:
      mes = 'Mayo';
      break;
    case 5:
      mes = 'Junio';
      break;
    case 6:
      mes = 'Julio';
      break;
    case 7:
      mes = 'Agosto';
      break;
    case 8:
      mes = 'Setiembre';
      break;
    case 9:
      mes = 'Octubre';
      break;
    case 10:
      mes = 'Noviembre';
      break;
    case 11:
      mes = 'Diciembre';
      break;
  }

  if (incluirDiaSemana) {
    return `${diaSemana} ${dia} de ${mes} de ${anio}`;
  } else {
    return `${dia} de ${mes} de ${anio}`;
  }
}

export const certificado_notarial_tooltip =
  'El certificado notarial debe acreditar: <br> - denominación del tipo de razón social <br> - domicilio constituido <br> - número de RUT Y BPS <br> - fecha de constitución <br> - personería jurídica <br> - plazo <br> - inscripción en el Registro Público de Comercio <br> - representación según estatuto o contrato social <br> - indicación de cargos <br> - números de las cédulas de identidad <br> - fecha del acta de designación de los representantes y distribución de los cargos';

export function removerTildes(palabra: string): string {
  return palabra
    .replace('á', 'a')
    .replace('é', 'e')
    .replace('í', 'i')
    .replace('ó', 'o')
    .replace('ú', 'u');
}
